<template>
<div class="content">
    <div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
        <sub-department>
        </sub-department> 
        </div>
    </div>  
    </div>
</div>
</template>
<script>
/* eslint-disable */
import subDepartment from './todo-sub-department'
export default {
    components: {
        subDepartment
    }
}
</script>
<style lang="scss">
</style>
<style>
    .fa-update{
       color:#07b22c;
       font-size:19px;
     }
     .link-default-departments{
        color: #666;
        font-size: 25px;
        font-weight: 500;
        line-height: 1.1;
     }
     .bg-breadcrum{
         background:#fff;
      }
</style>     


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-departments/base-sub-department.vue